import React, { useEffect, useState } from 'react'

interface IProps {
  value: number
}

const CourseType = ({ value }: IProps) => {
  const [title, setTitle] = useState('')

  useEffect(() => {
    switch (value) {
      case 1:
        setTitle('Autoguiado')
        break
      case 2:
        setTitle('Sincrónico - Externo')
        break
      case 3:
        setTitle('Sincrónico - Presencial')
        break
      case 4:
        setTitle('Externo')
        break
    }
  }, [value])

  return <div>{title}</div>
}

export default CourseType
